import React, { useContext, useEffect, useState } from "react";
import Sidenavigation from "../layouts/Sidenavigation";
import Topnavigation from "../layouts/Topnavigation";
import Quickbar from "../layouts/Quickbar";
import AuthContext from "../../context/auth-context";

export const Salestotalstockreport = () => {
  const ctx = useContext(AuthContext);
  const authPermission = localStorage.getItem("PermissionDetails");

  const [totalSaleHide, setHideTotalSale] = useState(true);
  const [mTotalSaleHide, setHideMTotalSale] = useState(true);
      
  useEffect(() => {
    JSON.parse(authPermission).forEach(function (loca) {
      if (
        loca.access_level.access_level == "ADMIN"
        ) {
          setHideTotalSale(false);
        }
    
      if (
          loca.access_level.access_level == "SUPER_ADMIN"
        ) {
          setHideMTotalSale(false);
        }
    });
  }, [authPermission]);

  return (
    <div
      className={
        ctx.darkMode
          ? "ms-body ms-aside-left-open ms-primary-theme ms-has-quickbar ms-dark-theme"
          : "ms-body ms-aside-left-open ms-primary-theme ms-has-quickbar"
      }
    >
      <Sidenavigation />
      <main className="body-content">
        <Topnavigation />
        <div
          hidden={mTotalSaleHide}
          style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginTop: 50
          }}
        >
          <iframe
            src="https://lookerstudio.google.com/embed/reporting/c0d3b992-a67a-4b31-9ac4-3a2202b663ea/page/p_5ng0bzfavd"
            style={{
              width: '98%',
              height: '1200px',
              border: 'none'
            }}
            title="Embedded Page"
            sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-downloads"
            allowFullScreen
          />
        </div>
      </main>
      <Quickbar />
    </div>
  );
};

export default Salestotalstockreport;
